import {defineStore} from "pinia";
import axios from "axios";
import {useUserStore} from './UserStore';
import Vue from "vue";

export const useProductsStore = defineStore('ProductsStore', {
    state: () => {
        return {


            search_params: {},


            search_cat: [],
            active_search: [],
            storages_cat: [],

            d_zones: {},
            products: {
                config: {
                    //page_steps: [24, 48, 96],
                    page_steps: [20,50,100],
                    page: 1,
                    on_load: false,
                    view: 'table',
                },
                s_keys: {
                    'start': 0,
                    'length': 24,//TODO: это надо вычислять на основе page_steps
                    'order_by': 'cae',
                    'order_dir': 'desc',
                },
                s_keys_dop:{
                    'active': false,
                    'type': 'type_components',
                    'sub_type': [],

                },
                s_results: {},
            },
            is_oth: 0,
            modal: {
                title: 'Заголовок',
                is_loading: false,
                product: {},
            },
        }
    },
    actions: {

        clear_search_keys() {
            this.products.s_keys = {};
            this.products.s_keys.start = 0;
            this.products.s_keys.length = this.products.config.page_steps[0];
            this.products.s_results = {};
        },

        switch_item_full_view(index) {
            if (this.products.s_results.items[index].expand === true) {
                this.products.s_results.items[index].expand = false
            } else {
                this.products.s_results.items[index].expand = true;
            }
        },


        async fill_products(is_oth = false) {

            let api_metod_url = 'search';
            const userStore = useUserStore()
            let params = new URLSearchParams();


            if (is_oth) {
                params.append('search_oth', true);

                userStore.user.oth.forEach((item, index) => {
                    if (item.active) {
                        params.append(
                            'oth_stocks',
                            item.oth_stock_id
                        );
                    }
                });
            }


            this.products.config.on_load = true;


            userStore.user.delivery_zones.forEach((item, index) => {
                if (item.active) {
                    params.append(
                        item.field,
                        item.value
                    );
                }
            });





            if(this.products.s_keys_dop.active === false) {

                // Проверяем и устанавливаем - оновной тип товара
                if (typeof (this.active_search.key) !== "undefined" && this.active_search.key !== null) {
                    params.append('type', this.active_search.key);
                }

                // Удаляем null и ранее установленные
                for (const index in this.products.s_keys) {

                    if (index in params) {
                        delete params[index]
                    }

                    //
                    if (this.products.s_keys[index] === null || this.products.s_keys[index] === undefined) {
                        //delete this.products.s_keys[index]
                    } else {
                        // Провоеряем пришел ли массив
                        //console.log(index,typeof (this.products.s_keys[index]));
                        if (typeof (this.products.s_keys[index]) === 'object') {
                            let counter = 0;
                            for (const key in this.products.s_keys[index]) {
                                params.append(index + '[' + counter + ']', this.products.s_keys[index][key]);
                                counter++;
                            }
                            // console.log('OBJECT:',index);
                        } else {
                            params.append(index, this.products.s_keys[index]);
                        }
                    }
                }
            }else {

                let counter = 0;

                for (const key in this.products.s_keys_dop.sub_type) {
                    params.append('sub_type' + '[' + counter + ']', this.products.s_keys_dop.sub_type[key]);
                    counter++;
                }

                params.append('type',this.products.s_keys_dop.type);
                params.append('start',this.products.s_keys.start);
                params.append('length',this.products.s_keys.length);
                params.append('order_by',this.products.s_keys.order_by);
                params.append('order_dir',this.products.s_keys.order_dir);
                params.append('count',this.products.s_keys.count);

            }


            let reqResult = (await axios.post( '/api/' + api_metod_url, params, {
                withCredentials: true,
            })).data;

            if (typeof (reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                Vue.prototype.$notifyInfo('Ошибка в получении данных');

            } else {

                for (let i = 0; i < reqResult.items.length; i++) {


                    // Устанавливаем общую цену, устанавливаем сколько добавлено в корзину
                    let minPrice = 0;


                    for (let w = 0; w < reqResult.items[i].price.length; w++) {

                        if (Number(reqResult.items[i].price[w].price_vip) < minPrice || minPrice === 0) {
                            minPrice = Number(reqResult.items[i].price[w].price_vip);
                        }

                        reqResult.items[i].price[w].in_basket = 0;
                        reqResult.items[i].price[w].filled = false;

                        if(reqResult.items[i].price[w].basket === true){
                            reqResult.items[i].price[w].in_basket = reqResult.items[i].price[w].basket_count;
                            reqResult.items[i].price[w].filled = true;
                        }


                        // Далее выясним сколько уже добавлено в корзину для данного товара
                        // TODO: не верно для не 1 склада!
                        /*for (const index in userStore.user.web_basket.items) {
                            if (userStore.user.web_basket.items[index].id === reqResult.items[i].uuid) {
                                reqResult.items[i].price[w].in_basket = userStore.user.web_basket.items[index].count;
                                reqResult.items[i].price[w].filled = true;

                            }
                        }*/

                        reqResult.items[i].price[w].at_load = false;

                    }


                    // TODO: возможно не верное назначение цены
                    reqResult.items[i].min_price = minPrice;
                    // Установим прочие переменнны для UI
                    reqResult.items[i].expand = false;

                }

                // TODO: Проверить поступившие данные!
                reqResult.start = Number(reqResult.start);
                reqResult.length = Number(reqResult.length);
                reqResult.count = Number(reqResult.count);
                this.products.s_keys.start = reqResult.start;
                this.products.s_keys.length = reqResult.length;
                this.products.s_keys.count = reqResult.count;

                if (reqResult.start > 0) {
                    reqResult.page = Math.floor((reqResult.start - 1) / reqResult.length);
                    console.log(reqResult.start,reqResult.length);
                } else {
                    reqResult.page = 1;
                }

                reqResult.pages = Math.floor(reqResult.count / reqResult.length)+1;


                this.products.s_results = reqResult;

            }
            this.products.config.on_load = false;
        },
        // Устарело - сравнить с действиями осущ. при наполнении списка товаров
        set_products_in_basket() {
            console.log('Обновление данных товаров зависящих от корзины');
            const userStore = useUserStore();
            // Идем по загруженным продуктам - определяя и передавая данные смежные с корзиной
            for (const index in this.products.s_results.items) {
                let set_count = 0;
                // Идем по всем товарам в корзине
                for (const index_b_item in userStore.user.web_basket.items) {
                    // Если uuid - совпадает с товаром в корзине - переходим к передаче кол-ва TODO: переделать т.к. ошибка с учетом разных складов
                    if (this.products.s_results.items[index].uuid === userStore.user.web_basket.items[index_b_item].uuid) {
                        set_count = userStore.user.web_basket.items[index_b_item].count;
                    }
                }
                // Идем по всем "складам" позиции и назначаем им количество добавленное в корзину TODO: переделать т.к. ошибка
                for (const index_price in this.products.s_results.items[index].price) {
                    // Передаем кол-во указанное в корзине
                    this.products.s_results.items[index].price[index_price].in_basket = set_count;
                }
            }
        },
        // async add_to_basket(index,index_store,uuid,id_price,id_storehouse,in_stock,in_basket){
        async add_to_basket(index, index_store, in_basket,oth_item) {


        },


        async fill_search_params() {
            const userStore = useUserStore()

            let reqResult = (await axios.get('/api/get_search_params', {
                withCredentials: true,
            })).data;

            if (typeof (reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                console.log('Error Get search_cat Data');
            }

            this.search_params = reqResult;

            this.fill_active_search(Object.keys(this.search_params)[0])

        },


        fill_active_search(select_key, is_oth = false) {


            // Очищаем заданные ключи поиска
            this.clear_search_keys();

            // TODO: Перенести в более логичное место
            const userStore = useUserStore()

            // Идем по "справочнику" типов товаров и при совпадении ключа - наполняем "активный поиск"
            for (var key in this.search_params) {
                if (key === select_key) {
                    this.active_search = this.search_params[key];
                }
            }

            // Если установлен флаг - наполняем данными - автоматически отправляем форму поиска
            if (this.products.config.default_fill === true) {
                // this.fill_products(is_oth);
            }


        },

        async fill_product_data(product_id) {
            this.modal.is_loading = true;
            const userStore = useUserStore();
            let reqResult = (await axios.get( '/api/product_info/' + product_id, {
                withCredentials: true,
            })).data;

            if (typeof (reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                console.log('Error Get Product Data');
            } else {
                this.modal.product = reqResult;
            }
            this.modal.is_loading = false;
        },

    }
})
